import React from 'react';
import PropTypes from 'prop-types';
import { TRANSLATE_PREFIX } from '../../consts';
import Input from '../Input';
import css from './MacroCell.css';

const TAB_PREFIX = `${TRANSLATE_PREFIX}.TRACKING_LINK_OPTIONS_TAB`;

const MacroCell = ({ row, setParam, readOnly, translate }) => {
    const {
        isCustomRow,
        macroErrorKey,
        macroErrorTranslateData,
        macroWarningKey,
        index,
        partner_macro: partnerMacro,
        isRequired,
    } = row;
    const placeholderKey = isCustomRow ? `${TAB_PREFIX}.CUSTOM_MACRO_PLACEHOLDER` : `${TAB_PREFIX}.MACRO_PLACEHOLDER`;
    const placeholder = readOnly ? '' : translate(placeholderKey);
    const errorMessage =
        !readOnly && macroErrorKey
            ? translate(`${TRANSLATE_PREFIX}.ERRORS.${macroErrorKey}`, macroErrorTranslateData || {})
            : null;
    const warningMessage =
        !readOnly && macroWarningKey ? translate(`${TRANSLATE_PREFIX}.ERRORS.${macroWarningKey}`) : null;

    return (
        <td>
            <Input
                value={partnerMacro || ''}
                placeholder={readOnly ? undefined : placeholder}
                onChange={val => setParam(index, 'partner_macro', val || undefined)}
                error={errorMessage}
                disabled={readOnly}
                required={isRequired}
            />
            {warningMessage && <span className={css.macroWarningHint}>{warningMessage}</span>}
        </td>
    );
};

MacroCell.propTypes = {
    row: PropTypes.shape({
        isCustomRow: PropTypes.bool.isRequired,
        macroErrorKey: PropTypes.string,
        macroErrorTranslateData: PropTypes.shape({ platformsList: PropTypes.string }),
        macroWarningKey: PropTypes.string,
        index: PropTypes.number.isRequired,
        partner_macro: PropTypes.string,
        isRequired: PropTypes.bool,
    }).isRequired,
    setParam: PropTypes.func.isRequired,
    readOnly: PropTypes.bool,
    translate: PropTypes.func.isRequired,
};

export default MacroCell;
